
export default {
  data() {
    return {
        totalRows: 0,//总条数
        currentPage: 1,// 当前页码 
        rows:20,
        domainCode:""
    }
  },

  created() {
    
  },
  mounted() {
    
  },
  beforeDestroy() {
  
  },
  methods:{
    handleCurrentChange(val) {
        this.loading = true
        this.getScoreAndCost(val)
  
      },
      setDomain(data) {
        this.domainCode = data;
        this.currentPag = 1;
        this.getPage()
      },
  }
};